if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt, forceTheme) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // When Monster Cart is active it binds its own add-to-cart handler to this
        // form, so it performs the add (and opens its drawer) on its own. Let it:
        // skip the theme's AJAX add so the item isn't added twice. preventDefault()
        // above already stops the native full-page POST to /cart.
        //
        // BUT: Monster's script tag can be present in the page before Monster has
        // finished initializing and bound its own click handler. In that window a
        // tap lands in a gap: the theme has stepped aside assuming Monster will
        // catch it, and nothing processes the tap (the "dead click" / "9 seconds of
        // nothing" symptom). Recovery: check the actual cart state (via /cart.js,
        // not a Monster UI element we don't control the markup for) a bit after the
        // tap, and if the cart never changed, run the theme's own AJAX add as a
        // fallback instead of leaving the tap silently swallowed.
       const monsterActive = typeof window.openCart === 'function' && typeof window.monster_refresh === 'function';
        if (monsterActive && !forceTheme) {
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) setTimeout(() => quickAddModal.hide(true), 300);

          fetch(`${routes.cart_url}.js`)
            .then((r) => r.json())
            .then((cartBefore) => {
              setTimeout(() => {
                fetch(`${routes.cart_url}.js`)
                  .then((r) => r.json())
                  .then((cartAfter) => {
                    if (cartAfter.item_count <= cartBefore.item_count) {
                      // Cart never changed: Monster didn't catch this tap. Recover
                      // by running the theme's own AJAX add-to-cart.
                      this.onSubmitHandler(evt, true);
                    }
                  })
                  .catch(() => {});
              }, 1400);
            })
            .catch(() => {});

          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}